var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopList',{ref:"TopList",attrs:{"navList":['用户管理', '用户组管理']},on:{"setType":_vm.setType}}),_c('div',{attrs:{"id":"sonUser"}},[_c('div',{staticClass:"content"},[(_vm.type === 0)?_c('UserList',{on:{"setTypeC":_vm.setTypeC}}):_vm._e(),(_vm.type === 1)?_c('UserGroupList',{on:{"setTypeC":_vm.setTypeC}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }